export const BASE_NAME = 'omni:payments:'
export const GLOBAL_ERROR = 'globalerror'
export const PAYEE_MANAGEMENT = 'payments' // sitesection
export const PAGE_VIEW = 'pageView'
export const ONCLICK = 'onClick'

const LANDING_PAGE = `${BASE_NAME}add biller:landing page`

// current page  in tealium
export const PAGES = {
  HOME: LANDING_PAGE,
  TEMPORARILY_UNAVAILABLE: `${BASE_NAME}system unavailable error`,
  EDIT_BILL: `${BASE_NAME}edit/delete biller`,
  FINAL_BILL_DASHBOARD: `${BASE_NAME}user insight page`,
  ENROLLMENT: `${BASE_NAME}enrollment:`
}

export const ERROR_MSG = {
  BASE_ERROR: `${BASE_NAME} error:`
}

// sub-section
export const SUBSITESECTION = {
  HOME: 'add biller',
  ADD_BILL: 'add biller',
  EDIT_BILL: 'manage biller',
  FIND_MY_BILL: 'find my bills',
  FINAL_BILL_DASHBOARD: 'payments',
  ENROLLMENT: 'enrollment'
}

export const EVENTS = {
  481: 'event481',
  560: 'event560',
  EDIT_BILL: 'edit bill',
  ADD_ADDRESS: 'Add address',
  ADD_EMAIL: 'Add email',
  ADD_PHONE: 'Add phone'
}

// switch condition
export const PAGE_NAMES = {
  ADD_BILL_HOME: 'addbillhome',
  ADD_BILL_MANUALLY: 'addbillmanually',
  EDIT_BILL: 'editbill',
  FIND_BILL_DASHBOARD: 'findabilldashboard',
  VERIFY_BILL_DAHSBOARD: 'verifybill'
}

// this is not needed
export const STRINGS = {
  BILL_PERSON_MANUALLY: `${BASE_NAME}add biller manually`,
  ENTER_PERSON_DETAILS: 'enter person details',
  ENTER_COMPANY_DETAILS: 'enter company details',
  POPUP: 'popup'
}

// current page for maual edit
export const PAGES_ADD_BILL = {
  ENTER_PERSON_DETAILS: `${BASE_NAME}add biller manually:enter person details`,
  ENTER_COMPANY_DETAILS: `${BASE_NAME}add biller manually:enter company details`,
  ENTER_COMPANY_DETAILS_BY_SEARCH: `${BASE_NAME}add biller by search:enter company details`
}

export const PAGES_MANAGE_BILL = {
  EDIT_BILL: `${BASE_NAME}edit/delete biller`,
  DELETE_BILL: `${BASE_NAME}delete biller:review`
}

export const PAGES_BILL_DISCOVERY = {
  CONSENT_POPUP: `${BASE_NAME}find my bills:introduction page`,
  FOUND_ASSOCIATED_BILLS: `${BASE_NAME}find my bills:found associated bills`,
  NO_BILLS: `${BASE_NAME}find my bills:verify bills:no bills`
}

export const PAGES_VERIFY_BILL_DISCOVERY = {
  VERIFY_BILLS: `${BASE_NAME}find my bills:verify bills`,
  VERIFICATION_ERROR: `${BASE_NAME}find my bills:verify bills:verification error`
}

export const PAGES_VERIFY_BILL_DISCOVERY_ERROR = {
  GENERIC_ERROR: `api error:500:service currently not available`,
  USER_ERROR: `user error:given answer doesn’t match to the file`
}

export const BILLER_ACCOUNT_TYPE = {
  INTERNAL: 'internal biller',
  EXTERNAL: 'external non ebiller',
  EXTERNAL_EBILLER: 'external ebiller'
}

export const LANGUAGE_TYPE = {
  SPANISH: 'spanish',
  ENGLISH: 'english'
}
